import { X } from "lucide-react"
import { useSearchParams } from "wouter"

import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"

import { LogsTable } from "./table"

export function LogsPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const sessionId = searchParams.get("sessionId") ?? ""

  return (
    <>
      {sessionId && (
        <div className="flex items-center gap-1">
          <Badge variant="secondary" className="font-mono">
            session: {sessionId}
          </Badge>
          <Button variant="ghost" size="icon-xs" onClick={() => setSearchParams({})}>
            <X />
          </Button>
        </div>
      )}
      <LogsTable key={sessionId} sessionId={sessionId} />
    </>
  )
}
